import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import Description from "../common/Description";
import BusinessBasicInfo from "./BusinessBasicInfo";
import SelectInput from "../common/SelectInput";
import { encrypt } from "../../BackendServices/generic";
import ErrorAlert from "../common/ErrorAlert";
import { validateCorporateAccount } from "../../BackendServices/registrationAPI";

const win = window;
const lang = win["lang"];
const rtl = lang === "ar";

class BillingAccount extends Component {
  state = {
    billingNumber: this.props.billingNumbers
      ? this.props.billingNumbers[0]
      : "",
    errors: { billingNumber: "" },
    genericError: null,
    isSuccess: false,
    isLoginBtn: false,
  };

  handleChange = (e) => {
    const option = this.props.billingNumbers[e.target.value];
    this.setState({
      [e.target.name]: option,
    });
  };

  handleBillingAccount = () => {
    const { transactionId } = this.props;
    const { billingNumber } = this.state;

    validateCorporateAccount(transactionId, encrypt(billingNumber)).then(
      (res) => {
        if (res.status.code === "MAPI-000") {
          this.setState({
            isSuccess: true,
            isLoginBtn: false,
          });
        } else {
          //error
          this.setState({
            isSuccess: false,
            isLoginBtn: true,
            genericError: rtl
              ? res.status.arabicDetail
              : res.status.englishDetail,
          });
        }
      }
    );
  };

  handleGotoLogin = () => {
    window.location = `/wps/portal/web/login-page?account_type=business`;
  };

  handleGoBack = () => {
    window.location = `/wps/portal/web/register?account_type=business`;
  };

  render() {
    const { t, apFirstName, companyName } = this.props;

    const rtl = win["lang"] === "ar";

    return (
      <>
        {!this.state.isSuccess && (
          <>
            <div className="loginIntroTextContainer">
              <h3>
                {t("Welcome")} {""}
                <>
                  <span style={{ margin: "0 5px" }}>
                    {rtl ? companyName : apFirstName}
                  </span>
                  <span style={{ margin: "0 5px" }}>
                    {rtl ? apFirstName : companyName}
                  </span>
                </>
              </h3>
              <Description description={"welcome_business_desc"} />
            </div>
            <div className="tabs">
              <div className="tab-content">
                {this.state.genericError && (
                  <ErrorAlert error={this.state.genericError} />
                )}
                <form onSubmit={this.handaleSubmit} id={"billing-form"}>
                  <SelectInput
                    id="billingNumber"
                    label={"billing_account_no"}
                    name={"billingNumber"}
                    value={this.state.billingNumber}
                    type={"select"}
                    error={this.state.errors.billingNumber}
                    handleChange={this.handleChange}
                    options={this.props.billingNumbers}
                  />

                  {!this.state.isLoginBtn ? (
                    <button
                      id="billing-continue-Btn"
                      type="button"
                      className="btn min_outlin_btn activationcodeButton active"
                      disabled={this.props.billingNumbers.length === 0}
                      onClick={this.handleBillingAccount}
                    >
                      {t("continue_btn")}
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                  ) : (
                    <>
                      <button
                        id="billing-goback-Btn"
                        type="button"
                        className="btn min_outlin_btn activationcodeButton"
                        onClick={this.handleGoBack}
                      >
                        {t("go_back_btn")}
                      </button>

                      <button
                        id="billing-gotologin-Btn"
                        type="button"
                        className="btn min_outlin_btn active marginTopButton"
                        onClick={this.handleGotoLogin}
                      >
                        {t("goto_login_btn")}
                      </button>
                    </>
                  )}
                </form>
              </div>
            </div>
          </>
        )}

        {this.state.isSuccess && (
          <BusinessBasicInfo
            redirectURL={this.props.redirectURL}
            billingNumber={this.state.billingNumber}
            transactionId={this.props.transactionId}
            {...this.props}
          />
        )}
      </>
    );
  }
}
export default withTranslation()(BillingAccount);
